import http from 'common-module/src/util/http';

/** 
 * 布局
 * @param issueTypeId 事项类型id
 * @param projectId 项目id
 * @returns {Promise<Array>}
*/
export const loadLayout = async (data = {}) => {
  return http.post('/issue/load-layout-v2', data);
};

/** 
 * 加载未加入布局字段列表
 * @param issueTypeId 事项类型id
 * @param projectId 项目id
 * @returns {Promise<Array>}
*/
export const loadUnusedFields = async (data = {}) => {
  return http.post('/profile/custom-field/to-add-field-list/v3', data);
};

/** 
 * 保存布局
 * @param filedList 字段列表
 * @param projectId 项目id
 * @param switches 功能开关列表
 * @returns {Promise<*>}
*/
export const saveLayout = async (data = {}) => {
  return http.post('/project-configuration/issue-type/save-layout-info', data);
};
